import { z } from 'zod';

import {
  UncefactUnitSchema,
  withoutObjectKeysWhereValueIs,
} from '@vestigas/utils';

export const zodUnitMappingsBaseSchema = z.object({
  issuerId: z.uuid().nullish().prefault(null),
  limit: z.number().int().positive().optional().prefault(1000), // Try to fetch all at once
  offset: z.number().int().min(0).optional().prefault(0),
  uncefactUnit: UncefactUnitSchema.optional().prefault(undefined),
});

export const zodUnitMappingsSearchParamsSchema =
  zodUnitMappingsBaseSchema.transform((value) =>
    withoutObjectKeysWhereValueIs(value, [null, undefined, '']),
  );
